import { render, staticRenderFns } from "./Kudo.vue?vue&type=template&id=56d0d3de&"
import script from "./Kudo.vue?vue&type=script&lang=js&"
export * from "./Kudo.vue?vue&type=script&lang=js&"
import style0 from "./Kudo.vue?vue&type=style&index=0&id=56d0d3de&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d0d3de')) {
      api.createRecord('56d0d3de', component.options)
    } else {
      api.reload('56d0d3de', component.options)
    }
    module.hot.accept("./Kudo.vue?vue&type=template&id=56d0d3de&", function () {
      api.rerender('56d0d3de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/Kudo.vue"
export default component.exports